export default function AnchorGeometryClass(){
    this.rows=iniRows,
    this.columns=iniColumns,
    this.rowSpacing=iniRowSpacing,
    this.colSpacing=iniColSpacing,
    this.aMinPerpEdge=[iniMinPerpEdge,iniMinPerpEdge,iniMinPerpEdge,iniMinPerpEdge],
    this.aMinEdgeDistance=[iniEdgeDistance,iniEdgeDistance,iniEdgeDistance,iniEdgeDistance],
    this.topEdge=iniTopEdge,
    this.bottomEdge=iniBottomEdge,
    this.leftEdge=iniLeftEdge,
    this.rightEdge=iniRightEdge
}

/*
var iniTensileStrength=58e3,
iniEmbedDepth=6,
iniHookLength=2,
iniFc=4e3,
iniThickness=15,
iniVX=2e3,
iniVY=2e3,
iniNZ=5e3,
ETFactoredLoadSource=["ACI 318-08","ACI 318-08 - Appendix D"],
ETAnchorLoadComboNames=["ACI Chapter 9","ACI Appendic C"],
AnchorLoadComboDict={"ACI 318-08":"ACI Chapter 9","ACI 318-08 - Appendix D":"ACI Appendic C"},
ETAnchorType=["Threaded Rod","Headed Bolt","Headed Stud","Hooked Bolt"],
anchorLoad = new AnchorLoadClass,
anchor = new AnchorBoltClass,
anchorGeometry = new AnchorGeometryClass;*/


var iniRows=3,
iniColumns=3,
iniRowSpacing=4,
iniColSpacing=4,
iniMinPerpEdge=1.5,
iniEdgeDistance=1.5,
iniTopEdge=5,
iniBottomEdge=5,
iniLeftEdge=5,
iniRightEdge=5,
Edge={Top:0,Bottom:1,Right:2,Left:3};

AnchorGeometryClass.prototype.Init=function(geometryJSON){
    if(geometryJSON){
        var g=geometryJSON;
        this.rows=g.rows,
        this.columns=g.columns,
        this.rowSpacing=g.rowSpacing,
        this.colSpacing=g.colSpacing,
        this.aMinPerpEdge=g.aMinPerpEdge,
        this.aMinEdgeDistance=g.aMinEdgeDistance,
        this.topEdge=g.topEdge,
        this.bottomEdge=g.bottomEdge,
        this.leftEdge=g.leftEdge,
        this.rightEdge=g.rightEdge
    } else 
    this.rows=iniRows,
    this.columns=iniColumns,
    this.rowSpacing=iniRowSpacing,
    this.colSpacing=iniColSpacing,
    this.aMinPerpEdge=[iniMinPerpEdge,iniMinPerpEdge,iniMinPerpEdge,iniMinPerpEdge],
    this.aMinEdgeDistance=[iniEdgeDistance,iniEdgeDistance,iniEdgeDistance,iniEdgeDistance],
    this.topEdge=iniTopEdge,
    this.bottomEdge=iniBottomEdge,
    this.leftEdge=iniLeftEdge,
    this.rightEdge=iniRightEdge
},
    
AnchorGeometryClass.prototype.BoltGroupHeight=function(){
    return(this.rows-1)*this.rowSpacing
},

AnchorGeometryClass.prototype.BoltGroupWidth=function(){
    return(this.columns-1)*this.colSpacing
},

AnchorGeometryClass.prototype.MinPerpendicularEdge=function(edge){
    switch(Number(edge)){
        case Edge.Top:
        case Edge.Bottom:
            return Math.min(this.leftEdge,this.rightEdge);
        case Edge.Left:
        case Edge.Right:
            return Math.min(this.topEdge,this.bottomEdge);
        default:return 0
    }
},

AnchorGeometryClass.prototype.MaxEdge=function(){
    for(var M=-1,edgeDistance=[Number(this.topEdge),Number(this.bottomEdge),Number(this.rightEdge),Number(this.leftEdge)],i=0;i<edgeDistance.length;i++)edgeDistance[i]>M&&(M=edgeDistance[i]);
    return Number(M)
},

AnchorGeometryClass.prototype.MaxEdgeToALimit=function(v){
    for(var M=0,edgeDistance=[Number(this.topEdge),Number(this.bottomEdge),Number(this.rightEdge),Number(this.leftEdge)],i=0;i<edgeDistance.length;i++)edgeDistance[i]<v&edgeDistance[i]>M&&(M=edgeDistance[i]);
    return Number(M)
},

AnchorGeometryClass.prototype.MinEdge=function(){
    for(var M=1e10,edgeDistance=[Number(this.topEdge),Number(this.bottomEdge),Number(this.rightEdge),Number(this.leftEdge)],i=0;i<edgeDistance.length;i++)edgeDistance[i]<M&&(M=edgeDistance[i]);
    return Number(M)
},

AnchorGeometryClass.prototype.MinSpacing=function(){
    return Math.min(this.rowSpacing,this.colSpacing)
},

AnchorGeometryClass.prototype.MaxSpacing=function(){
    return Math.max(this.rowSpacing,this.colSpacing)
},

AnchorGeometryClass.prototype.EdgesLessThan=function(x){
    const edgeDistance = [this.topEdge, this.bottomEdge, this.rightEdge, this.leftEdge]
    
    let N = 0

    for(let i=0; i < edgeDistance.length; i++) {
        if(Number(edgeDistance[i]) < x) { N++ }
    }
    return N
},

AnchorGeometryClass.prototype.NumberOfBolts=function(){
    return this.rows*this.columns
};

AnchorGeometryClass.prototype.getWidth=function() {
    return this.leftEdge + this.colSpacing * (this.columns - 1) + this.rightEdge; 
}

AnchorGeometryClass.prototype.getHeight=function() {
    return this.topEdge + this.rowSpacing * (this.rows - 1) + this.bottomEdge; 
}

AnchorGeometryClass.prototype.getBoltDiameter = function() {
    return oAnchor.GetDiameter();
}
